import BaseEvent from '@/utils/base/BaseEvent'

class EventHub extends BaseEvent {
    constructor() {
        super()
        this._eventMgrs = new Map()
    }

    /**
     * @api
     * 获取事件管理器
     * @param {String} namespace
     * @returns {EventMgr}
     */
    getEventMgrByNameSpace(namespace) {
        if (!this._eventMgrs.has(namespace)) {
            this._eventMgrs.set(namespace, new EventMgr(namespace))
        }
        return this._eventMgrs.get(namespace)
    }

    /**
     * @private
     * @param {*} handler
     * @param {*} type
     * @param  {...any} rest
     */
    _dispatch(handler, type, ...rest) {
        const sp = type.split('/')
        if (sp.length > 1) {
            const _type = sp.slice(1).join('/')
            return this.getEventMgrByNameSpace(sp[0])[handler](_type, ...rest)
        }
        return super[handler](type, ...rest)
    }

    on(type, func) {
        return this._dispatch('on', type, func)
    }

    once(type, func) {
        return this._dispatch('once', type, func)
    }

    off(type, func) {
        return this._dispatch('off', type, func)
    }

    /**
     * 触发事件
     * @param {String} type
     * @param  {...any} rest
     */
    fire(type, ...rest) {
        return this._dispatch('fire', type, ...rest)
    }
}

class EventMgr extends BaseEvent {
    constructor(namespace) {
        super()
        this._namespace = namespace
    }
}

const EVENTHUB = new EventHub()

global.EVENTHUB = EVENTHUB
